import React from 'react'

import TextArea from '../Fields/TextArea'

const ModuleNineteen = (props) => {

	return (
		<div>
			<p>I have been informed by Dr. Esposito of my current condition and recommendation for treatment which includes:</p>
			<TextArea
				controlFunc={props.addToForm}
				inputType={"text"}
				name={"treatment"}
				value={props.consentForm.treatment}
			/>

			<p>I also understand that a separate procedure to obtain bone for grafting is intended to remove portions of bone from my <strong>left and or right ramus (lower jaw), or left or right tuberosity (upper jaw)</strong> and place it in the area to be treated.</p>
			<p>In addition to the risks of the primary surgical procedure which have been explained to me separately, I understand that bone grafting itself involves risks. My doctor has explained to me that such risks include, but are not limited to the following:</p>
		</div>
	)
}

export default ModuleNineteen


// WEBPACK FOOTER //
// ./src/components/Modules/19.js